import * as React from 'react'

function SvgId(props) {
	return (
		<svg viewBox="0 0 3 2" width="1em" height="1em" {...props}>
			<path fill="#FFF" d="M0 0h3v2H0z" />
			<path fill="#CE1126" d="M0 0h3v1H0z" />
		</svg>
	)
}

export default SvgId
